import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {Anchor, AnchorOffsetType, AnchorPoint} from '../../../../../models/Anchor';
import {v4} from 'uuid';
import {ExpandedPart} from '../../../../../business/expanded_parts/ExpandedPartsProvider';

interface OwnProps {
    expandedPart: ExpandedPart;
    onSubmit: (playbackrate: number, anchor: Anchor) => void;
    onCancel: () => void;
}

function generateAnchorPointText(anchorPoint: AnchorPoint): string {
    switch (anchorPoint) {
        case AnchorPoint.Start:
            return 'Start of part';
        case AnchorPoint.End:
            return 'End of part';
    }
}

function generateAnchorOffsetTypeText(anchorOffsetType: AnchorOffsetType): string {
    switch (anchorOffsetType) {
        case AnchorOffsetType.TimeSeconds:
            return 'Seconds';
    }
}

export const AnchorStepComponent: FunctionComponent<OwnProps> = ({expandedPart, onSubmit, onCancel}) => {
    const [playbackrate, setPlaybackrate] = useState<number | null>(1);
    const [anchorPoint, setAnchorPoint] = useState<AnchorPoint>(AnchorPoint.Start);
    const [offsetType, setOffsetType] = useState<AnchorOffsetType>(AnchorOffsetType.TimeSeconds);
    const [offsetValue, setOffsetValue] = useState<number | null>(0);

    return (
        <>
            <div className="modal-header">
                <h2>Set anchor</h2>
            </div>
            <div className="modal-body">
                <div className="add-media-item-wizard">
                    <form>
                        <div className="form-group">
                            <label htmlFor="playbackrate">Playback rate</label>
                            <input
                                id="playbackrate"
                                type="number"
                                name="playbackrate"
                                className="form-control"
                                value={playbackrate || ''}
                                onChange={(e) => {
                                    setPlaybackrate(e.target.value === '' ? null : parseFloat(e.target.value));
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="anchor-point">Anchor point</label>
                            <select
                                className="form-control-select"
                                id="anchor-point"
                                name="anchor-point"
                                onChange={(e) => setAnchorPoint(e.target.value as AnchorPoint)}
                                value={anchorPoint}
                            >
                                {Object.values(AnchorPoint).map((ap) => (
                                    <option key={ap} value={ap}>
                                        {generateAnchorPointText(ap)}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="offset-type">Type</label>
                            <select
                                className="form-control-select"
                                id="offset-type"
                                name="offset-type"
                                onChange={(e) => setOffsetType(e.target.value as AnchorOffsetType)}
                                value={offsetType}
                            >
                                {Object.values(AnchorOffsetType).map((ot) => (
                                    <option key={ot} value={ot}>
                                        {generateAnchorOffsetTypeText(ot)}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="offset">Offset</label>
                            <input
                                id="offset"
                                type="number"
                                name="distance_meters"
                                className="form-control"
                                value={offsetValue === null ? '' : offsetValue}
                                onChange={(e) => {
                                    setOffsetValue(e.target.value === '' ? null : parseInt(e.target.value, 10));
                                }}
                            />
                        </div>
                    </form>
                </div>
            </div>
            <div className="modal-footer">
                <button
                    className="btn btn-primary pull-right"
                    disabled={offsetValue === null || playbackrate === null}
                    onClick={() => {
                        if (offsetValue === null) {
                            return;
                        }
                        if (playbackrate === null) {
                            return;
                        }
                        onSubmit(playbackrate, {
                            __uuid: v4(),
                            __expandedPartUuid: expandedPart.__uuid,
                            anchor_point: anchorPoint,
                            offset_type: offsetType,
                            offset_value: offsetValue,
                        });
                    }}
                >
                    Add
                </button>
                <button className="btn btn-secondary pull-right" onClick={onCancel}>
                    Cancel
                </button>
            </div>
        </>
    );
};
